// // import React, { useState, useEffect } from "react";
// // import "./App.css";
// // import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams } from "react-router-dom";
// // import axios from "axios";
// // import { Button } from "./components/ui/button";
// // import { Input } from "./components/ui/input";
// // import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card";
// // import { Badge } from "./components/ui/badge";
// // import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs";
// // import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./components/ui/dialog";
// // import { Label } from "./components/ui/label";
// // import { Textarea } from "./components/ui/textarea";
// // import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./components/ui/select";
// // import { Separator } from "./components/ui/separator";
// // import { Search, Video, FileText, Image, Upload, Plus, Edit, Trash2, LogOut, User, ExternalLink, Smartphone, Instagram, Facebook, MessageCircle, Newspaper, Menu, Home, Settings, BarChart3, Folder, ExternalLinkIcon } from "lucide-react";
// // import { toast, Toaster } from "sonner";
// // import FolderContentView from "./components/FolderContentView";
// // import ModernHomepage from "./components/ModernHomepage";
// // import ArticleView from "./components/ArticleView";
// // import SlideManager from "./components/SlideManager";
// // import { Switch } from "./components/ui/switch"; // Fixed typo from Swithc to Switch

// // const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// // const API = `${BACKEND_URL}/api`;

// // // Utility function to add cache-busting for R2 URLs
// // const addCacheBusting = (url) => {
// //   if (!url) return url;
// //   if (url.includes('.r2.dev') || url.includes('cloudflare')) {
// //     const separator = url.includes('?') ? '&' : '?';
// //     return `${url}${separator}cb=${Date.now()}`;
// //   }
// //   return url;
// // };

// // // Auth context
// // const AuthContext = React.createContext();

// // const AuthProvider = ({ children }) => {
// //   const [isAuthenticated, setIsAuthenticated] = useState(false);
// //   const [user, setUser] = useState(null);
// //   const [loading, setLoading] = useState(true);

// //   useEffect(() => {
// //     checkAuth();
// //   }, []);

// //   const checkAuth = async () => {
// //     const token = localStorage.getItem('auth_token');
// //     if (token) {
// //       try {
// //         const response = await axios.get(`${API}/auth/me`, {
// //           headers: { Authorization: `Bearer ${token}` }
// //         });
// //         setUser(response.data);
// //         setIsAuthenticated(true);
// //       } catch (error) {
// //         localStorage.removeItem('auth_token');
// //         setIsAuthenticated(false);
// //         setUser(null);
// //       }
// //     }
// //     setLoading(false);
// //   };

// //   const login = async (username, password) => {
// //     try {
// //       const response = await axios.post(`${API}/auth/login`, {
// //         username,
// //         password
// //       });

// //       const { token } = response.data;
// //       localStorage.setItem('auth_token', token);
// //       setIsAuthenticated(true);

// //       const userResponse = await axios.get(`${API}/auth/me`, {
// //         headers: { Authorization: `Bearer ${token}` }
// //       });
// //       setUser(userResponse.data);

// //       return { success: true };
// //     } catch (error) {
// //       return { 
// //         success: false, 
// //         error: error.response?.data?.detail || 'Login failed' 
// //       };
// //     }
// //   };

// //   const logout = () => {
// //     localStorage.removeItem('auth_token');
// //     setIsAuthenticated(false);
// //     setUser(null);
// //   };

// //   const value = {
// //     isAuthenticated,
// //     user,
// //     login,
// //     logout,
// //     loading
// //   };

// //   return (
// //     <AuthContext.Provider value={value}>
// //       {children}
// //     </AuthContext.Provider>
// //   );
// // };

// // const useAuth = () => {
// //   const context = React.useContext(AuthContext);
// //   if (!context) {
// //     throw new Error('useAuth must be used within an AuthProvider');
// //   }
// //   return context;
// // };

// // // Public Search Page
// // const SearchPage = () => {
// //   return <ModernHomepage />;
// // };

// // // Login Page
// // const LoginPage = () => {
// //   const [formData, setFormData] = useState({ username: "", password: "" });
// //   const [loading, setLoading] = useState(false);
// //   const { login, isAuthenticated } = useAuth();
// //   const navigate = useNavigate();

// //   useEffect(() => {
// //     if (isAuthenticated) {
// //       navigate('/admin');
// //     }
// //   }, [isAuthenticated, navigate]);

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setLoading(true);

// //     const result = await login(formData.username, formData.password);

// //     if (result.success) {
// //       toast.success("Login berhasil!");
// //       navigate('/admin');
// //     } else {
// //       toast.error(result.error);
// //     }

// //     setLoading(false);
// //   };

// //   return (
// //     <div className="min-h-screen bg-gray-50 flex items-center justify-center">
// //       <Card className="w-full max-w-md">
// //         <CardHeader>
// //           <CardTitle>Admin Login</CardTitle>
// //           <CardDescription>Masukkan kredensial admin</CardDescription>
// //         </CardHeader>
// //         <CardContent>
// //           <form onSubmit={handleSubmit} className="space-y-4">
// //             <div>
// //               <Label htmlFor="username">Username</Label>
// //               <Input
// //                 id="username"
// //                 type="text"
// //                 value={formData.username}
// //                 onChange={(e) => setFormData({...formData, username: e.target.value})}
// //                 required
// //               />
// //             </div>
// //             <div>
// //               <Label htmlFor="password">Password</Label>
// //               <Input
// //                 id="password"
// //                 type="password"
// //                 value={formData.password}
// //                 onChange={(e) => setFormData({...formData, password: e.target.value})}
// //                 required
// //               />
// //             </div>
// //             <Button type="submit" className="w-full" disabled={loading}>
// //               {loading ? "Loading..." : "Login"}
// //             </Button>
// //           </form>
// //         </CardContent>
// //       </Card>
// //     </div>
// //   );
// // };

// // // Admin Dashboard
// // const AdminDashboard = () => {
// //   const [contents, setContents] = useState([]);
// //   const [folders, setFolders] = useState([]);
// //   const [selectedFolder, setSelectedFolder] = useState(null);
// //   const [loading, setLoading] = useState(true);
// //   const [uploadLoading, setUploadLoading] = useState(false);
// //   const [selectedContent, setSelectedContent] = useState(null);
// //   const [dialogOpen, setDialogOpen] = useState(false);
// //   const [folderDialogOpen, setFolderDialogOpen] = useState(false);
// //   const [sidebarOpen, setSidebarOpen] = useState(false);
// //   const [activeTab, setActiveTab] = useState('content');
// //   const [searchAnalytics, setSearchAnalytics] = useState(null);
// //   const [selectedContents, setSelectedContents] = useState([]);
// //   const { logout } = useAuth();

// //   const [formData, setFormData] = useState({
// //     title: "",
// //     content_type: "article",
// //     content_data: {},
// //     tags: [],
// //     folder: "",
// //     description: ""
// //   });

// //   const [folderFormData, setFolderFormData] = useState({
// //     name: "",
// //     description: "",
// //     color: "#3B82F6"
// //   });

// //   useEffect(() => {
// //     fetchFolders();
// //   }, []);

// //   useEffect(() => {
// //     if (selectedFolder !== null) {
// //       fetchFolderContents();
// //     }
// //   }, [selectedFolder]);

// //   useEffect(() => {
// //     if (activeTab === 'analytics') {
// //       fetchSearchAnalytics();
// //     }
// //   }, [activeTab]);

// //   // Effect untuk memuat script TikTok dan Instagram saat konten berubah atau dialog dibuka
// //   useEffect(() => {
// //     // TikTok
// //     const tiktokScriptId = 'tiktok-embed-script';
// //     if (!document.getElementById(tiktokScriptId)) {
// //         const script = document.createElement('script');
// //         script.id = tiktokScriptId;
// //         script.src = 'https://www.tiktok.com/embed.js';
// //         script.async = true;
// //         document.body.appendChild(script);
// //     } else if (window.tiktok) {
// //         window.tiktok.load();
// //     }

// //     // Instagram
// //     const instaScriptId = 'instagram-embed-script';
// //     if (!document.getElementById(instaScriptId)) {
// //         const script = document.createElement('script');
// //         script.id = instaScriptId;
// //         script.src = '//www.instagram.com/embed.js';
// //         script.async = true;
// //         document.body.appendChild(script);
// //     } else if (window.instgrm) {
// //         window.instgrm.Embeds.process();
// //     }
// //   }, [dialogOpen, contents]); 

// //   const fetchSearchAnalytics = async () => {
// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       const response = await axios.get(`${API}/admin/analytics/search`, {
// //         headers: { Authorization: `Bearer ${token}` }
// //       });
// //       setSearchAnalytics(response.data);
// //     } catch (error) {
// //       toast.error("Error mengambil analytics");
// //     }
// //   };

// //   const fetchFolders = async () => {
// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       const response = await axios.get(`${API}/admin/folders`, {
// //         headers: { Authorization: `Bearer ${token}` }
// //       });
// //       setFolders(response.data);
// //     } catch (error) {
// //       toast.error("Error mengambil folders");
// //     }
// //   };

// //   const handleFileUpload = async (event) => {
// //     const file = event.target.files[0];
// //     if (!file) return;

// //     setUploadLoading(true);
// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       const formDataUpload = new FormData();
// //       formDataUpload.append('file', file);
// //       formDataUpload.append('folder', 'content-files');

// //       const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
// //         headers: { 
// //           Authorization: `Bearer ${token}`,
// //           'Content-Type': 'multipart/form-data'
// //         }
// //       });

// //       setFormData(prev => ({
// //         ...prev,
// //         content_data: {
// //           ...prev.content_data,
// //           url: response.data.file_url,
// //           file_name: response.data.file_name,
// //           file_type: response.data.file_type,
// //           file_size: response.data.file_size
// //         }
// //       }));

// //       toast.success("File berhasil diupload!");
// //     } catch (error) {
// //       toast.error("Error upload file: " + (error.response?.data?.detail || "Unknown error"));
// //     } finally {
// //       setUploadLoading(false);
// //     }
// //   };

// //   const handleThumbnailUpload = async (event) => {
// //     const file = event.target.files[0];
// //     if (!file) return;

// //     setUploadLoading(true);
// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       const formDataUpload = new FormData();
// //       formDataUpload.append('file', file);
// //       formDataUpload.append('folder', 'thumbnails');

// //       const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
// //         headers: { 
// //           Authorization: `Bearer ${token}`,
// //           'Content-Type': 'multipart/form-data'
// //         }
// //       });

// //       setFormData(prev => ({
// //         ...prev,
// //         content_data: {
// //           ...prev.content_data,
// //           thumbnail_url: response.data.file_url
// //         }
// //       }));

// //       toast.success("Thumbnail berhasil diupload!");
// //     } catch (error) {
// //       toast.error("Error upload thumbnail: " + (error.response?.data?.detail || "Unknown error"));
// //     } finally {
// //       setUploadLoading(false);
// //     }
// //   };

// //   const handlePdfUpload = async (event) => {
// //     const file = event.target.files[0];
// //     if (!file) return;

// //     setUploadLoading(true);
// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       const formDataUpload = new FormData();
// //       formDataUpload.append('file', file);
// //       formDataUpload.append('folder', 'pdfs');

// //       const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
// //         headers: { 
// //           Authorization: `Bearer ${token}`,
// //           'Content-Type': 'multipart/form-data'
// //         }
// //       });

// //       setFormData(prev => ({
// //         ...prev,
// //         content_data: {
// //           ...prev.content_data,
// //           pdf_url: response.data.file_url,
// //           pdf_name: response.data.file_name
// //         }
// //       }));

// //       toast.success("PDF berhasil diupload!");
// //     } catch (error) {
// //       toast.error("Error upload PDF: " + (error.response?.data?.detail || "Unknown error"));
// //     } finally {
// //       setUploadLoading(false);
// //     }
// //   };

// //   const fetchFolderContents = async () => {
// //     setLoading(true);
// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       const response = await axios.get(`${API}/admin/folders/${selectedFolder}/contents`, {
// //         headers: { Authorization: `Bearer ${token}` }
// //       });
// //       setContents(response.data);
// //     } catch (error) {
// //       toast.error("Error mengambil konten folder");
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const createFolder = async () => {
// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       await axios.post(`${API}/admin/folders`, folderFormData, {
// //         headers: { Authorization: `Bearer ${token}` }
// //       });
// //       toast.success("Folder berhasil dibuat!");
// //       setFolderDialogOpen(false);
// //       setFolderFormData({ name: "", description: "", color: "#3B82F6" });
// //       fetchFolders();
// //     } catch (error) {
// //       toast.error("Error membuat folder: " + (error.response?.data?.detail || "Unknown error"));
// //     }
// //   };

// //   const moveContentToFolder = async (targetFolder = null) => {
// //     if (selectedContents.length === 0) {
// //       toast.error("Pilih konten yang ingin dipindah");
// //       return;
// //     }

// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       await axios.post(`${API}/admin/folders/move`, {
// //         content_ids: selectedContents,
// //         target_folder: targetFolder
// //       }, {
// //         headers: { Authorization: `Bearer ${token}` }
// //       });
// //       toast.success("Konten berhasil dipindah!");
// //       setSelectedContents([]);
// //       fetchFolderContents();
// //     } catch (error) {
// //       toast.error("Error memindah konten");
// //     }
// //   };

// //   const openEditDialog = (content) => {
// //     setSelectedContent(content);
// //     setFormData({
// //       title: content.title,
// //       content_type: content.content_type,
// //       content_data: content.content_data,
// //       tags: content.tags,
// //       folder: content.folder || "no-folder",
// //       description: content.description || ""
// //     });
// //     setDialogOpen(true);
// //   };

// //   const handleDelete = async (contentId) => {
// //     if (!window.confirm("Apakah Anda yakin ingin menghapus konten ini?")) return;

// //     try {
// //       const token = localStorage.getItem('auth_token');
// //       await axios.delete(`${API}/admin/content/${contentId}`, {
// //         headers: { Authorization: `Bearer ${token}` }
// //       });
// //       toast.success("Konten berhasil dihapus!");
// //       fetchFolderContents();
// //     } catch (error) {
// //       toast.error("Error menghapus konten");
// //     }
// //   };

// //   const handleSubmit = async (e) => {
// //     e.preventDefault();

// //     try {
// //       const token = localStorage.getItem('auth_token');

// //       const submitData = {
// //         ...formData,
// //         folder: formData.folder === 'no-folder' ? null : formData.folder
// //       };

// //       if (selectedContent) {
// //         await axios.put(`${API}/admin/content/${selectedContent.id}`, submitData, {
// //           headers: { Authorization: `Bearer ${token}` }
// //         });
// //         toast.success("Konten berhasil diperbarui!");
// //       } else {
// //         await axios.post(`${API}/admin/content`, submitData, {
// //           headers: { Authorization: `Bearer ${token}` }
// //         });
// //         toast.success("Konten berhasil dibuat!");
// //       }

// //       setDialogOpen(false);
// //       resetForm();
// //       if (selectedFolder !== null) {
// //         fetchFolderContents();
// //       }
// //     } catch (error) {
// //       toast.error("Error menyimpan konten: " + (error.response?.data?.detail || "Unknown error"));
// //     }
// //   };

// //   const resetForm = () => {
// //     setFormData({
// //       title: "",
// //       content_type: "article",
// //       content_data: {},
// //       tags: [],
// //       folder: selectedFolder && selectedFolder !== 'no-folder' ? selectedFolder : "no-folder",
// //       description: ""
// //     });
// //     setSelectedContent(null);
// //   };

// //   const renderContent = () => {
// //     if (activeTab === 'upload') {
// //       return (
// //         <div className="space-y-6">
// //           <h2 className="text-2xl font-bold text-gray-800">Upload Files</h2>
// //           <Card className="p-6">
// //             <CardContent>
// //               <div className="text-center py-8">
// //                 <Upload className="w-16 h-16 text-gray-400 mx-auto mb-4" />
// //                 <p className="text-gray-600">Upload file langsung ke R2 Storage</p>
// //               </div>
// //             </CardContent>
// //           </Card>
// //         </div>
// //       );
// //     }

// //     if (activeTab === 'slides') return <SlideManager />;
// //     if (activeTab === 'analytics') return <div>Analytics Placeholder</div>;

// //     if (selectedFolder === null) {
// //       return (
// //         <div className="space-y-6">
// //           <div className="flex justify-between items-center">
// //             <h2 className="text-2xl font-bold text-gray-800">Folder Konten</h2>
// //             <Dialog open={folderDialogOpen} onOpenChange={setFolderDialogOpen}>
// //               <DialogTrigger asChild>
// //                 <Button>
// //                   <Plus className="w-4 h-4 mr-2" />
// //                   Buat Folder Baru
// //                 </Button>
// //               </DialogTrigger>
// //               <DialogContent>
// //                 <DialogHeader>
// //                   <DialogTitle>Buat Folder Baru</DialogTitle>
// //                 </DialogHeader>
// //                 <div className="space-y-4">
// //                   <div>
// //                     <Label htmlFor="folder_name">Nama Folder</Label>
// //                     <Input
// //                       id="folder_name"
// //                       value={folderFormData.name}
// //                       onChange={(e) => setFolderFormData({...folderFormData, name: e.target.value})}
// //                       placeholder="Nama folder (contoh: QRIS, PLN, PPN)"
// //                     />
// //                   </div>
// //                   <div>
// //                     <Label htmlFor="folder_description">Deskripsi</Label>
// //                     <Textarea
// //                       id="folder_description"
// //                       value={folderFormData.description}
// //                       onChange={(e) => setFolderFormData({...folderFormData, description: e.target.value})}
// //                       placeholder="Deskripsi folder (opsional)"
// //                     />
// //                   </div>
// //                   <div>
// //                     <Label htmlFor="folder_color">Warna</Label>
// //                     <Input
// //                       id="folder_color"
// //                       type="color"
// //                       value={folderFormData.color}
// //                       onChange={(e) => setFolderFormData({...folderFormData, color: e.target.value})}
// //                     />
// //                   </div>
// //                   <Button onClick={createFolder} className="w-full">
// //                     Buat Folder
// //                   </Button>
// //                 </div>
// //               </DialogContent>
// //             </Dialog>
// //           </div>

// //           <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
// //             <Card 
// //               className="cursor-pointer hover:shadow-md transition-shadow border-2 border-dashed border-gray-300"
// //               onClick={() => setSelectedFolder('no-folder')}
// //             >
// //               <CardContent className="p-6 text-center">
// //                 <Folder className="w-12 h-12 mx-auto mb-4 text-gray-400" />
// //                 <h3 className="font-semibold text-gray-700">Tanpa Folder</h3>
// //                 <p className="text-sm text-gray-500 mt-1">Konten yang belum dikategorikan</p>
// //               </CardContent>
// //             </Card>

// //             {folders.map((folder) => (
// //               <Card 
// //                 key={folder.id}
// //                 className="cursor-pointer hover:shadow-md transition-shadow"
// //                 onClick={() => setSelectedFolder(folder.id)}
// //                 style={{ borderTop: `4px solid ${folder.color}` }}
// //               >
// //                 <CardContent className="p-6 text-center">
// //                   <div 
// //                     className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center"
// //                     style={{ backgroundColor: folder.color + '20' }}
// //                   >
// //                     <Folder className="w-6 h-6" style={{ color: folder.color }} />
// //                   </div>
// //                   <h3 className="font-semibold">{folder.name}</h3>
// //                   {folder.description && (
// //                     <p className="text-sm text-gray-500 mt-1">{folder.description}</p>
// //                   )}
// //                 </CardContent>
// //               </Card>
// //             ))}
// //           </div>
// //         </div>
// //       );
// //     }

// //     return (
// //       <div className="space-y-6">
// //         <div className="flex justify-between items-center">
// //           <div className="flex items-center gap-3">
// //             <Button 
// //               variant="outline" 
// //               size="sm"
// //               onClick={() => setSelectedFolder(null)}
// //             >
// //               ← Kembali
// //             </Button>
// //             <h2 className="text-2xl font-bold text-gray-800">
// //               {folders.find(f => f.id === selectedFolder)?.name || 'Tanpa Folder'}
// //             </h2>
// //             <Badge variant="outline">{contents.length} konten</Badge>
// //           </div>
// //           <div className="flex gap-2">
// //             {selectedContents.length > 0 && (
// //               <div className="flex gap-2">
// //                 <Select onValueChange={(value) => moveContentToFolder(value === 'no-folder' ? null : value)}>
// //                   <SelectTrigger className="w-40">
// //                     <SelectValue placeholder="Pindah ke..." />
// //                   </SelectTrigger>
// //                   <SelectContent>
// //                     <SelectItem value="no-folder">Tanpa Folder</SelectItem>
// //                     {folders.filter(f => f.id !== selectedFolder).map((folder) => (
// //                       <SelectItem key={folder.id} value={folder.id}>{folder.name}</SelectItem>
// //                     ))}
// //                   </SelectContent>
// //                 </Select>
// //                 <Button variant="outline" onClick={() => setSelectedContents([])}>
// //                   Batal Pilih ({selectedContents.length})
// //                 </Button>
// //               </div>
// //             )}
// //             <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
// //               <DialogTrigger asChild>
// //                 <Button onClick={resetForm}>
// //                   <Plus className="w-4 h-4 mr-2" />
// //                   Tambah Konten
// //                 </Button>
// //               </DialogTrigger>
// //               <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
// //                 <DialogHeader>
// //                   <DialogTitle>
// //                     {selectedContent ? "Edit Konten" : "Tambah Konten Baru"}
// //                   </DialogTitle>
// //                 </DialogHeader>
// //                 <form onSubmit={handleSubmit} className="space-y-4">
// //                   <div>
// //                     <Label htmlFor="title">Judul</Label>
// //                     <Input
// //                       id="title"
// //                       value={formData.title}
// //                       onChange={(e) => setFormData({...formData, title: e.target.value})}
// //                       required
// //                     />
// //                   </div>

// //                   <div>
// //                     <Label htmlFor="content_type">Tipe Konten</Label>
// //                     <Select 
// //                       value={formData.content_type} 
// //                       onValueChange={(value) => setFormData({...formData, content_type: value, content_data: {}})}
// //                     >
// //                       <SelectTrigger>
// //                         <SelectValue />
// //                       </SelectTrigger>
// //                       <SelectContent>
// //                         <SelectItem value="article">Artikel</SelectItem>
// //                         <SelectItem value="video_youtube">Video YouTube</SelectItem>
// //                         <SelectItem value="video_tiktok">Video TikTok</SelectItem>
// //                         <SelectItem value="instagram_reel">Instagram Reel</SelectItem>
// //                         <SelectItem value="instagram_feed">Instagram Feed</SelectItem>
// //                         <SelectItem value="video_upload">Video Upload</SelectItem>
// //                         <SelectItem value="image">Gambar</SelectItem>
// //                         <SelectItem value="file">File</SelectItem>
// //                       </SelectContent>
// //                     </Select>
// //                   </div>

// //                   {/* DYNAMIC INPUTS BASED ON TYPE */}
// //                   {formData.content_type === 'article' && (
// //                     <div className="space-y-4">
// //                       <div>
// //                         <Label>Teks Artikel</Label>
// //                         <Textarea 
// //                           value={formData.content_data.text || ""} 
// //                           onChange={(e) => setFormData({
// //                             ...formData, 
// //                             content_data: {...formData.content_data, text: e.target.value}
// //                           })} 
// //                           rows={6} 
// //                         />
// //                       </div>
// //                       <div>
// //                         <Label>Upload PDF</Label>
// //                         <Input 
// //                           type="file" 
// //                           accept=".pdf" 
// //                           onChange={handlePdfUpload} 
// //                           disabled={uploadLoading} 
// //                         />
// //                       </div>
// //                     </div>
// //                   )}

// //                   {(formData.content_type === 'instagram_reel' || formData.content_type === 'instagram_feed') && (
// //                     <div className="space-y-4 p-4 border rounded-lg bg-gray-50">
// //                       <div className="bg-blue-50 p-3 rounded border border-blue-200 text-sm text-blue-800">
// //                         <strong>Tips:</strong> Untuk tampilan terbaik, gunakan <strong>Embed Code</strong>.
// //                         <ol className="list-decimal ml-4 mt-1">
// //                           <li>Buka Instagram di browser/desktop</li>
// //                           <li>Klik titik tiga (...) di postingan/reels</li>
// //                           <li>Pilih "Embed" atau "Sematkan"</li>
// //                           <li>Klik "Copy Embed Code" dan paste di bawah ini</li>
// //                         </ol>
// //                       </div>
// //                       <div>
// //                         <Label className="text-base font-semibold">Kode Sematan (Embed Code)</Label>
// //                         <Textarea 
// //                           value={formData.content_data.embed_code || ""} 
// //                           onChange={(e) => setFormData({
// //                             ...formData, 
// //                             content_data: {...formData.content_data, embed_code: e.target.value}
// //                           })}
// //                           placeholder='<blockquote class="instagram-media" ... > ... </blockquote>'
// //                           className="font-mono text-xs mt-2"
// //                           rows={6}
// //                         />
// //                       </div>
// //                       <div className="relative py-2">
// //                         <div className="absolute inset-0 flex items-center">
// //                           <span className="w-full border-t" />
// //                         </div>
// //                         <div className="relative flex justify-center text-xs uppercase">
// //                           <span className="bg-gray-50 px-2 text-muted-foreground">
// //                             Atau Manual (Tidak Disarankan)
// //                           </span>
// //                         </div>
// //                       </div>
// //                       <div>
// //                         <Label>URL Instagram</Label>
// //                         <Input 
// //                           value={formData.content_data.original_url || ""} 
// //                           onChange={(e) => setFormData({
// //                             ...formData, 
// //                             content_data: {...formData.content_data, original_url: e.target.value}
// //                           })} 
// //                           placeholder="https://instagram.com/..." 
// //                         />
// //                       </div>
// //                       <div>
// //                         <Label>Upload Thumbnail (Opsional)</Label>
// //                         <Input 
// //                           type="file" 
// //                           accept="image/*" 
// //                           onChange={handleThumbnailUpload} 
// //                         />
// //                       </div>
// //                     </div>
// //                   )}

// //                   {formData.content_type === 'video_youtube' && (
// //                     <div>
// //                       <Label>URL Embed YouTube</Label>
// //                       <Input 
// //                         value={formData.content_data.embed_url || ""} 
// //                         onChange={(e) => setFormData({
// //                           ...formData, 
// //                           content_data: {...formData.content_data, embed_url: e.target.value}
// //                         })} 
// //                       />
// //                     </div>
// //                   )}

// //                   {formData.content_type === 'video_tiktok' && (
// //                     <div>
// //                       <Label>URL TikTok</Label>
// //                       <Input 
// //                         value={formData.content_data.original_url || ""} 
// //                         onChange={(e) => setFormData({
// //                           ...formData, 
// //                           content_data: {...formData.content_data, original_url: e.target.value}
// //                         })} 
// //                       />
// //                     </div>
// //                   )}

// //                   {(formData.content_type === 'image' || formData.content_type === 'video_upload' || formData.content_type === 'file') && (
// //                     <div>
// //                       <Label>Upload File</Label>
// //                       <Input 
// //                         type="file" 
// //                         onChange={handleFileUpload} 
// //                         disabled={uploadLoading} 
// //                       />
// //                     </div>
// //                   )}

// //                   {['image', 'video_upload'].includes(formData.content_type) && (
// //                     <div className="p-4 border rounded-lg space-y-4 bg-gray-50">
// //                       <h4 className="font-medium text-sm text-gray-700">Opsi Tampilan Media</h4>
// //                       <div>
// //                         <Label htmlFor="aspect_ratio">Aspect Ratio</Label>
// //                         <Select
// //                           value={formData.content_data.display_options?.aspect_ratio || "auto"}
// //                           onValueChange={(value) => setFormData(prev => ({
// //                             ...prev,
// //                             content_data: {
// //                               ...prev.content_data,
// //                               display_options: { 
// //                                 ...prev.content_data.display_options, 
// //                                 aspect_ratio: value 
// //                               }
// //                             }
// //                           }))}
// //                         >
// //                           <SelectTrigger id="aspect_ratio">
// //                             <SelectValue placeholder="Pilih rasio" />
// //                           </SelectTrigger>
// //                           <SelectContent>
// //                             <SelectItem value="auto">Otomatis</SelectItem>
// //                             <SelectItem value="16/9">16:9 (Landscape)</SelectItem>
// //                             <SelectItem value="9/16">9:16 (Portrait)</SelectItem>
// //                             <SelectItem value="4/3">4:3 (Standard)</SelectItem>
// //                             <SelectItem value="1/1">1:1 (Square)</SelectItem>
// //                           </SelectContent>
// //                         </Select>
// //                       </div>
// //                     </div>
// //                   )}

// //                   <div>
// //                     <Label htmlFor="folder">Folder</Label>
// //                     <Select 
// //                       value={formData.folder || "no-folder"} 
// //                       onValueChange={(value) => setFormData({...formData, folder: value})}
// //                     >
// //                       <SelectTrigger>
// //                         <SelectValue placeholder="Pilih folder (opsional)" />
// //                       </SelectTrigger>
// //                       <SelectContent>
// //                         <SelectItem value="no-folder">Tanpa Folder</SelectItem>
// //                         {folders.map((folder) => (
// //                           <SelectItem key={folder.id} value={folder.id}>{folder.name}</SelectItem>
// //                         ))}
// //                       </SelectContent>
// //                     </Select>
// //                   </div>

// //                   <div>
// //                     <Label htmlFor="tags">Tags (pisahkan dengan koma)</Label>
// //                     <Input
// //                       id="tags"
// //                       value={formData.tags.join(", ")}
// //                       onChange={(e) => setFormData({
// //                         ...formData, 
// //                         tags: e.target.value.split(",").map(tag => tag.trim())
// //                       })}
// //                       placeholder="Kasir, QRIS, PPN"
// //                     />
// //                   </div>

// //                   <div>
// //                     <Label htmlFor="description">Deskripsi</Label>
// //                     <Textarea
// //                       id="description"
// //                       value={formData.description}
// //                       onChange={(e) => setFormData({...formData, description: e.target.value})}
// //                       placeholder="Deskripsi singkat konten..."
// //                     />
// //                   </div>

// //                   <Button type="submit" className="w-full" disabled={uploadLoading}>
// //                     {uploadLoading ? "Uploading..." : selectedContent ? "Update Konten" : "Simpan Konten"}
// //                   </Button>
// //                 </form>
// //               </DialogContent>
// //             </Dialog>
// //           </div>
// //         </div>

// //         {loading ? (
// //           <div className="text-center py-8">
// //             <p>Loading...</p>
// //           </div>
// //         ) : (
// //           <FolderContentView 
// //             contents={contents}
// //             selectedContents={selectedContents}
// //             setSelectedContents={setSelectedContents}
// //             openEditDialog={openEditDialog}
// //             handleDelete={handleDelete}
// //           />
// //         )}
// //       </div>
// //     );
// //   };

// //   return (
// //     <div className="min-h-screen bg-gray-50 flex">
// //       <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform lg:translate-x-0 lg:static lg:inset-0`}>
// //         <div className="flex items-center justify-between h-16 px-6 border-b">
// //           <h1 className="text-xl font-bold text-gray-800">Admin Panel</h1>
// //           <Button
// //             variant="ghost"
// //             size="sm"
// //             className="lg:hidden"
// //             onClick={() => setSidebarOpen(false)}
// //           >
// //             ×
// //           </Button>
// //         </div>

// //         <nav className="mt-8">
// //           <button
// //             onClick={() => setActiveTab('content')}
// //             className={`w-full flex items-center px-6 py-3 ${
// //               activeTab === 'content' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
// //             }`}
// //           >
// //             <Folder className="w-5 h-5 mr-3" />
// //             Kelola Konten
// //           </button>
// //           <button
// //             onClick={() => setActiveTab('slides')}
// //             className={`w-full flex items-center px-6 py-3 ${
// //               activeTab === 'slides' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
// //             }`}
// //           >
// //             <Image className="w-5 h-5 mr-3" />
// //             Kelola Slides
// //           </button>
// //           <button
// //             onClick={() => setActiveTab('upload')}
// //             className={`w-full flex items-center px-6 py-3 ${
// //               activeTab === 'upload' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
// //             }`}
// //           >
// //             <Upload className="w-5 h-5 mr-3" />
// //             Upload Files
// //           </button>
// //         </nav>

// //         <div className="absolute bottom-0 left-0 right-0 p-6 border-t">
// //           <Button
// //             variant="outline"
// //             onClick={logout}
// //             className="w-full"
// //           >
// //             <LogOut className="w-4 h-4 mr-2" />
// //             Logout
// //           </Button>
// //         </div>
// //       </div>

// //       <div className="flex-1 flex flex-col lg:ml-0">
// //         <header className="bg-white shadow-sm border-b h-16 flex items-center justify-between px-6">
// //           <Button
// //             variant="ghost"
// //             size="sm"
// //             className="lg:hidden"
// //             onClick={() => setSidebarOpen(true)}
// //           >
// //             <Menu className="w-5 h-5" />
// //           </Button>

// //           <div className="flex items-center space-x-4">
// //             <span className="text-sm text-gray-600">Welcome, Admin</span>
// //             <User className="w-8 h-8 text-gray-400" />
// //           </div>
// //         </header>

// //         <main className="flex-1 p-6">
// //           {renderContent()}
// //         </main>
// //       </div>

// //       {sidebarOpen && (
// //         <div 
// //           className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
// //           onClick={() => setSidebarOpen(false)}
// //         />
// //       )}
// //     </div>
// //   );
// // };

// // // Protected Route Component
// // const ProtectedRoute = ({ children }) => {
// //   const { isAuthenticated, loading } = useAuth();

// //   if (loading) {
// //     return <div className="flex items-center justify-center h-screen">Loading...</div>;
// //   }

// //   return isAuthenticated ? children : <Navigate to="/admin/login" />;
// // };

// // // Article Page Component
// // const ArticlePage = () => {
// //   const { id } = useParams();
// //   const navigate = useNavigate();

// //   return (
// //     <ArticleView 
// //       articleId={id} 
// //       onBack={() => navigate('/')}
// //     />
// //   );
// // };

// // // Main App Component
// // function App() {
// //   return (
// //     <AuthProvider>
// //       <BrowserRouter>
// //         <Routes>
// //           <Route path="/" element={<ModernHomepage />} />
// //           <Route path="/article/:id" element={<ArticlePage />} />
// //           <Route path="/admin/login" element={<LoginPage />} />
// //           <Route 
// //             path="/admin" 
// //             element={
// //               <ProtectedRoute>
// //                 <AdminDashboard />
// //               </ProtectedRoute>
// //             } 
// //           />
// //         </Routes>
// //         <Toaster />
// //       </BrowserRouter>
// //     </AuthProvider>
// //   );
// // }

// // export default App;

// import React, { useState, useEffect } from "react";
// import "./App.css";
// import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import { Button } from "./components/ui/button";
// import { Input } from "./components/ui/input";
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card";
// import { Badge } from "./components/ui/badge";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs";
// import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./components/ui/dialog";
// import { Label } from "./components/ui/label";
// import { Textarea } from "./components/ui/textarea";
// import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./components/ui/select";
// import { Separator } from "./components/ui/separator";
// import { Search, Video, FileText, Image, Upload, Plus, Edit, Trash2, LogOut, User, ExternalLink, Smartphone, Instagram, Facebook, MessageCircle, Newspaper, Menu, Home, Settings, BarChart3, Folder, ExternalLinkIcon } from "lucide-react";
// import { toast, Toaster } from "sonner";
// import FolderContentView from "./components/FolderContentView";
// import ModernHomepage from "./components/ModernHomepage";
// import ArticleView from "./components/ArticleView";
// import SlideManager from "./components/SlideManager";
// import { Switch } from "./components/ui/switch";

// const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
// const API = `${BACKEND_URL}/api`;

// // Utility function to add cache-busting for R2 URLs
// const addCacheBusting = (url) => {
//   if (!url) return url;
//   if (url.includes('.r2.dev') || url.includes('cloudflare')) {
//     const separator = url.includes('?') ? '&' : '?';
//     return `${url}${separator}cb=${Date.now()}`;
//   }
//   return url;
// };

// const AuthContext = React.createContext();

// const AuthProvider = ({ children }) => {
//   const [isAuthenticated, setIsAuthenticated] = useState(false);
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     checkAuth();
//   }, []);

//   const checkAuth = async () => {
//     const token = localStorage.getItem('auth_token');
//     if (token) {
//       try {
//         const response = await axios.get(`${API}/auth/me`, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         setUser(response.data);
//         setIsAuthenticated(true);
//       } catch (error) {
//         localStorage.removeItem('auth_token');
//         setIsAuthenticated(false);
//         setUser(null);
//       }
//     }
//     setLoading(false);
//   };

//   const login = async (username, password) => {
//     try {
//       const response = await axios.post(`${API}/auth/login`, {
//         username,
//         password
//       });

//       const { token } = response.data;
//       localStorage.setItem('auth_token', token);
//       setIsAuthenticated(true);

//       const userResponse = await axios.get(`${API}/auth/me`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setUser(userResponse.data);

//       return { success: true };
//     } catch (error) {
//       return {
//         success: false,
//         error: error.response?.data?.detail || 'Login failed'
//       };
//     }
//   };

//   const logout = () => {
//     localStorage.removeItem('auth_token');
//     setIsAuthenticated(false);
//     setUser(null);
//   };

//   const value = {
//     isAuthenticated,
//     user,
//     login,
//     logout,
//     loading
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

// const useAuth = () => {
//   const context = React.useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// // Public Search Page
// const SearchPage = () => {
//   return <ModernHomepage />;
// };

// // Login Page
// const LoginPage = () => {
//   const [formData, setFormData] = useState({ username: "", password: "" });
//   const [loading, setLoading] = useState(false);
//   const { login, isAuthenticated } = useAuth();
//   const navigate = useNavigate();

//   useEffect(() => {
//     if (isAuthenticated) {
//       navigate('/admin');
//     }
//   }, [isAuthenticated, navigate]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const result = await login(formData.username, formData.password);

//     if (result.success) {
//       toast.success("Login berhasil!");
//       navigate('/admin');
//     } else {
//       toast.error(result.error);
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 flex items-center justify-center">
//       <Card className="w-full max-w-md">
//         <CardHeader>
//           <CardTitle>Admin Login</CardTitle>
//           <CardDescription>Masukkan kredensial admin</CardDescription>
//         </CardHeader>
//         <CardContent>
//           <form onSubmit={handleSubmit} className="space-y-4">
//             <div>
//               <Label htmlFor="username">Username</Label>
//               <Input
//                 id="username"
//                 type="text"
//                 value={formData.username}
//                 onChange={(e) => setFormData({ ...formData, username: e.target.value })}
//                 required
//               />
//             </div>
//             <div>
//               <Label htmlFor="password">Password</Label>
//               <Input
//                 id="password"
//                 type="password"
//                 value={formData.password}
//                 onChange={(e) => setFormData({ ...formData, password: e.target.value })}
//                 required
//               />
//             </div>
//             <Button type="submit" className="w-full" disabled={loading}>
//               {loading ? "Loading..." : "Login"}
//             </Button>
//           </form>
//         </CardContent>
//       </Card>
//     </div>
//   );
// };

// // Admin Dashboard
// const AdminDashboard = () => {
//   const [contents, setContents] = useState([]);
//   const [folders, setFolders] = useState([]);
//   const [selectedFolder, setSelectedFolder] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [uploadLoading, setUploadLoading] = useState(false);
//   const [selectedContent, setSelectedContent] = useState(null);
//   const [dialogOpen, setDialogOpen] = useState(false);
//   const [folderDialogOpen, setFolderDialogOpen] = useState(false);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [activeTab, setActiveTab] = useState('content');
//   const [searchAnalytics, setSearchAnalytics] = useState(null);
//   const [selectedContents, setSelectedContents] = useState([]);
//   const { logout } = useAuth();

//   const [formData, setFormData] = useState({
//     title: "",
//     content_type: "article",
//     content_data: {},
//     tags: [],
//     folder: "",
//     description: ""
//   });

//   const [folderFormData, setFolderFormData] = useState({
//     name: "",
//     description: "",
//     color: "#3B82F6"
//   });

//   useEffect(() => {
//     fetchFolders();
//   }, []);

//   useEffect(() => {
//     if (selectedFolder !== null) {
//       fetchFolderContents();
//     }
//   }, [selectedFolder]);

//   useEffect(() => {
//     if (activeTab === 'analytics') {
//       fetchSearchAnalytics();
//     }
//   }, [activeTab]);

//   // Effect for scripts
//   useEffect(() => {
//     const tiktokScriptId = 'tiktok-embed-script';
//     if (!document.getElementById(tiktokScriptId)) {
//       const script = document.createElement('script');
//       script.id = tiktokScriptId;
//       script.src = 'https://www.tiktok.com/embed.js';
//       script.async = true;
//       document.body.appendChild(script);
//     } else if (window.tiktok) {
//       window.tiktok.load();
//     }

//     const instaScriptId = 'instagram-embed-script';
//     if (!document.getElementById(instaScriptId)) {
//       const script = document.createElement('script');
//       script.id = instaScriptId;
//       script.src = '//www.instagram.com/embed.js';
//       script.async = true;
//       document.body.appendChild(script);
//     } else if (window.instgrm) {
//       window.instgrm.Embeds.process();
//     }
//   }, [dialogOpen, contents]);

//   const fetchSearchAnalytics = async () => {
//     try {
//       const token = localStorage.getItem('auth_token');
//       const response = await axios.get(`${API}/admin/analytics/search`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setSearchAnalytics(response.data);
//     } catch (error) {
//       toast.error("Error mengambil analytics");
//     }
//   };

//   const fetchFolders = async () => {
//     try {
//       const token = localStorage.getItem('auth_token');
//       const response = await axios.get(`${API}/admin/folders`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setFolders(response.data);
//     } catch (error) {
//       toast.error("Error mengambil folders");
//     }
//   };

//   const handleFileUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setUploadLoading(true);
//     try {
//       const token = localStorage.getItem('auth_token');
//       const formDataUpload = new FormData();
//       formDataUpload.append('file', file);
//       formDataUpload.append('folder', 'content-files');

//       const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       // Keep existing content_data, update url info
//       setFormData(prev => ({
//         ...prev,
//         content_data: {
//           ...prev.content_data,
//           url: response.data.file_url,
//           file_name: response.data.file_name,
//           file_type: response.data.file_type,
//           file_size: response.data.file_size
//         }
//       }));

//       toast.success("File berhasil diupload!");
//     } catch (error) {
//       toast.error("Error upload file: " + (error.response?.data?.detail || "Unknown error"));
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   // NEW FUNCTION: Handle Cover Image Upload for Files
//   const handleCoverImageUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setUploadLoading(true);
//     try {
//       const token = localStorage.getItem('auth_token');
//       const formDataUpload = new FormData();
//       formDataUpload.append('file', file);
//       formDataUpload.append('folder', 'covers'); // Upload to 'covers' folder

//       const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       // Save to content_data.cover_image_url
//       setFormData(prev => ({
//         ...prev,
//         content_data: {
//           ...prev.content_data,
//           cover_image_url: response.data.file_url
//         }
//       }));

//       toast.success("Cover image berhasil diupload!");
//     } catch (error) {
//       toast.error("Error upload cover: " + (error.response?.data?.detail || "Unknown error"));
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   const handleThumbnailUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setUploadLoading(true);
//     try {
//       const token = localStorage.getItem('auth_token');
//       const formDataUpload = new FormData();
//       formDataUpload.append('file', file);
//       formDataUpload.append('folder', 'thumbnails');

//       const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       setFormData(prev => ({
//         ...prev,
//         content_data: {
//           ...prev.content_data,
//           thumbnail_url: response.data.file_url
//         }
//       }));

//       toast.success("Thumbnail berhasil diupload!");
//     } catch (error) {
//       toast.error("Error upload thumbnail: " + (error.response?.data?.detail || "Unknown error"));
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   const handlePdfUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;

//     setUploadLoading(true);
//     try {
//       const token = localStorage.getItem('auth_token');
//       const formDataUpload = new FormData();
//       formDataUpload.append('file', file);
//       formDataUpload.append('folder', 'pdfs');

//       const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           'Content-Type': 'multipart/form-data'
//         }
//       });

//       setFormData(prev => ({
//         ...prev,
//         content_data: {
//           ...prev.content_data,
//           pdf_url: response.data.file_url,
//           pdf_name: response.data.file_name
//         }
//       }));

//       toast.success("PDF berhasil diupload!");
//     } catch (error) {
//       toast.error("Error upload PDF: " + (error.response?.data?.detail || "Unknown error"));
//     } finally {
//       setUploadLoading(false);
//     }
//   };

//   const fetchFolderContents = async () => {
//     setLoading(true);
//     try {
//       const token = localStorage.getItem('auth_token');
//       const response = await axios.get(`${API}/admin/folders/${selectedFolder}/contents`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       setContents(response.data);
//     } catch (error) {
//       toast.error("Error mengambil konten folder");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const createFolder = async () => {
//     try {
//       const token = localStorage.getItem('auth_token');
//       await axios.post(`${API}/admin/folders`, folderFormData, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       toast.success("Folder berhasil dibuat!");
//       setFolderDialogOpen(false);
//       setFolderFormData({ name: "", description: "", color: "#3B82F6" });
//       fetchFolders();
//     } catch (error) {
//       toast.error("Error membuat folder: " + (error.response?.data?.detail || "Unknown error"));
//     }
//   };

//   const moveContentToFolder = async (targetFolder = null) => {
//     if (selectedContents.length === 0) {
//       toast.error("Pilih konten yang ingin dipindah");
//       return;
//     }

//     try {
//       const token = localStorage.getItem('auth_token');
//       await axios.post(`${API}/admin/folders/move`, {
//         content_ids: selectedContents,
//         target_folder: targetFolder
//       }, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       toast.success("Konten berhasil dipindah!");
//       setSelectedContents([]);
//       fetchFolderContents();
//     } catch (error) {
//       toast.error("Error memindah konten");
//     }
//   };

//   const openEditDialog = (content) => {
//     setSelectedContent(content);
//     setFormData({
//       title: content.title,
//       content_type: content.content_type,
//       content_data: content.content_data,
//       tags: content.tags,
//       folder: content.folder || "no-folder",
//       description: content.description || ""
//     });
//     setDialogOpen(true);
//   };

//   const handleDelete = async (contentId) => {
//     if (!window.confirm("Apakah Anda yakin ingin menghapus konten ini?")) return;

//     try {
//       const token = localStorage.getItem('auth_token');
//       await axios.delete(`${API}/admin/content/${contentId}`, {
//         headers: { Authorization: `Bearer ${token}` }
//       });
//       toast.success("Konten berhasil dihapus!");
//       fetchFolderContents();
//     } catch (error) {
//       toast.error("Error menghapus konten");
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     try {
//       const token = localStorage.getItem('auth_token');

//       const submitData = {
//         ...formData,
//         folder: formData.folder === 'no-folder' ? null : formData.folder
//       };

//       if (selectedContent) {
//         await axios.put(`${API}/admin/content/${selectedContent.id}`, submitData, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         toast.success("Konten berhasil diperbarui!");
//       } else {
//         await axios.post(`${API}/admin/content`, submitData, {
//           headers: { Authorization: `Bearer ${token}` }
//         });
//         toast.success("Konten berhasil dibuat!");
//       }

//       setDialogOpen(false);
//       resetForm();
//       if (selectedFolder !== null) {
//         fetchFolderContents();
//       }
//     } catch (error) {
//       toast.error("Error menyimpan konten: " + (error.response?.data?.detail || "Unknown error"));
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       title: "",
//       content_type: "article",
//       content_data: {},
//       tags: [],
//       folder: selectedFolder && selectedFolder !== 'no-folder' ? selectedFolder : "no-folder",
//       description: ""
//     });
//     setSelectedContent(null);
//   };

//   const renderContent = () => {
//     if (activeTab === 'upload') {
//       return (
//         <div className="space-y-6">
//           <h2 className="text-2xl font-bold text-gray-800">Upload Files</h2>
//           <Card className="p-6">
//             <CardContent>
//               <div className="text-center py-8">
//                 <Upload className="w-16 h-16 text-gray-400 mx-auto mb-4" />
//                 <p className="text-gray-600">Upload file langsung ke R2 Storage</p>
//               </div>
//             </CardContent>
//           </Card>
//         </div>
//       );
//     }

//     if (activeTab === 'slides') return <SlideManager />;
//     if (activeTab === 'analytics') return <div>Analytics Placeholder</div>;

//     if (selectedFolder === null) {
//       return (
//         <div className="space-y-6">
//           <div className="flex justify-between items-center">
//             <h2 className="text-2xl font-bold text-gray-800">Folder Konten</h2>
//             <Dialog open={folderDialogOpen} onOpenChange={setFolderDialogOpen}>
//               <DialogTrigger asChild>
//                 <Button>
//                   <Plus className="w-4 h-4 mr-2" />
//                   Buat Folder Baru
//                 </Button>
//               </DialogTrigger>
//               <DialogContent>
//                 <DialogHeader>
//                   <DialogTitle>Buat Folder Baru</DialogTitle>
//                 </DialogHeader>
//                 <div className="space-y-4">
//                   <div>
//                     <Label htmlFor="folder_name">Nama Folder</Label>
//                     <Input
//                       id="folder_name"
//                       value={folderFormData.name}
//                       onChange={(e) => setFolderFormData({ ...folderFormData, name: e.target.value })}
//                       placeholder="Nama folder (contoh: QRIS, PLN, PPN)"
//                     />
//                   </div>
//                   <div>
//                     <Label htmlFor="folder_description">Deskripsi</Label>
//                     <Textarea
//                       id="folder_description"
//                       value={folderFormData.description}
//                       onChange={(e) => setFolderFormData({ ...folderFormData, description: e.target.value })}
//                       placeholder="Deskripsi folder (opsional)"
//                     />
//                   </div>
//                   <div>
//                     <Label htmlFor="folder_color">Warna</Label>
//                     <Input
//                       id="folder_color"
//                       type="color"
//                       value={folderFormData.color}
//                       onChange={(e) => setFolderFormData({ ...folderFormData, color: e.target.value })}
//                     />
//                   </div>
//                   <Button onClick={createFolder} className="w-full">
//                     Buat Folder
//                   </Button>
//                 </div>
//               </DialogContent>
//             </Dialog>
//           </div>

//           <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
//             <Card
//               className="cursor-pointer hover:shadow-md transition-shadow border-2 border-dashed border-gray-300"
//               onClick={() => setSelectedFolder('no-folder')}
//             >
//               <CardContent className="p-6 text-center">
//                 <Folder className="w-12 h-12 mx-auto mb-4 text-gray-400" />
//                 <h3 className="font-semibold text-gray-700">Tanpa Folder</h3>
//                 <p className="text-sm text-gray-500 mt-1">Konten yang belum dikategorikan</p>
//               </CardContent>
//             </Card>

//             {folders.map((folder) => (
//               <Card
//                 key={folder.id}
//                 className="cursor-pointer hover:shadow-md transition-shadow"
//                 onClick={() => setSelectedFolder(folder.id)}
//                 style={{ borderTop: `4px solid ${folder.color}` }}
//               >
//                 <CardContent className="p-6 text-center">
//                   <div
//                     className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center"
//                     style={{ backgroundColor: folder.color + '20' }}
//                   >
//                     <Folder className="w-6 h-6" style={{ color: folder.color }} />
//                   </div>
//                   <h3 className="font-semibold">{folder.name}</h3>
//                   {folder.description && (
//                     <p className="text-sm text-gray-500 mt-1">{folder.description}</p>
//                   )}
//                 </CardContent>
//               </Card>
//             ))}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="space-y-6">
//         <div className="flex justify-between items-center">
//           <div className="flex items-center gap-3">
//             <Button
//               variant="outline"
//               size="sm"
//               onClick={() => setSelectedFolder(null)}
//             >
//               ← Kembali
//             </Button>
//             <h2 className="text-2xl font-bold text-gray-800">
//               {folders.find(f => f.id === selectedFolder)?.name || 'Tanpa Folder'}
//             </h2>
//             <Badge variant="outline">{contents.length} konten</Badge>
//           </div>
//           <div className="flex gap-2">
//             {selectedContents.length > 0 && (
//               <div className="flex gap-2">
//                 <Select onValueChange={(value) => moveContentToFolder(value === 'no-folder' ? null : value)}>
//                   <SelectTrigger className="w-40">
//                     <SelectValue placeholder="Pindah ke..." />
//                   </SelectTrigger>
//                   <SelectContent>
//                     <SelectItem value="no-folder">Tanpa Folder</SelectItem>
//                     {folders.filter(f => f.id !== selectedFolder).map((folder) => (
//                       <SelectItem key={folder.id} value={folder.id}>{folder.name}</SelectItem>
//                     ))}
//                   </SelectContent>
//                 </Select>
//                 <Button variant="outline" onClick={() => setSelectedContents([])}>
//                   Batal Pilih ({selectedContents.length})
//                 </Button>
//               </div>
//             )}
//             <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
//               <DialogTrigger asChild>
//                 <Button onClick={resetForm}>
//                   <Plus className="w-4 h-4 mr-2" />
//                   Tambah Konten
//                 </Button>
//               </DialogTrigger>
//               <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
//                 <DialogHeader>
//                   <DialogTitle>
//                     {selectedContent ? "Edit Konten" : "Tambah Konten Baru"}
//                   </DialogTitle>
//                 </DialogHeader>
//                 <form onSubmit={handleSubmit} className="space-y-4">
//                   <div>
//                     <Label htmlFor="title">Judul</Label>
//                     <Input
//                       id="title"
//                       value={formData.title}
//                       onChange={(e) => setFormData({ ...formData, title: e.target.value })}
//                       required
//                     />
//                   </div>

//                   <div>
//                     <Label htmlFor="content_type">Tipe Konten</Label>
//                     <Select
//                       value={formData.content_type}
//                       onValueChange={(value) => setFormData({ ...formData, content_type: value, content_data: {} })}
//                     >
//                       <SelectTrigger>
//                         <SelectValue />
//                       </SelectTrigger>
//                       <SelectContent>
//                         <SelectItem value="article">Artikel</SelectItem>
//                         <SelectItem value="video_youtube">Video YouTube</SelectItem>
//                         <SelectItem value="video_tiktok">Video TikTok</SelectItem>
//                         <SelectItem value="instagram_reel">Instagram Reel</SelectItem>
//                         <SelectItem value="instagram_feed">Instagram Feed</SelectItem>
//                         <SelectItem value="video_upload">Video Upload</SelectItem>
//                         <SelectItem value="image">Gambar</SelectItem>
//                         <SelectItem value="file">File</SelectItem>
//                       </SelectContent>
//                     </Select>
//                   </div>

//                   {/* DYNAMIC INPUTS BASED ON TYPE */}
//                   {formData.content_type === 'article' && (
//                     <div className="space-y-4">
//                       <div>
//                         <Label>Teks Artikel</Label>
//                         <Textarea
//                           value={formData.content_data.text || ""}
//                           onChange={(e) => setFormData({
//                             ...formData,
//                             content_data: { ...formData.content_data, text: e.target.value }
//                           })}
//                           rows={6}
//                         />
//                       </div>
//                       <div>
//                         <Label>Upload PDF</Label>
//                         <Input
//                           type="file"
//                           accept=".pdf"
//                           onChange={handlePdfUpload}
//                           disabled={uploadLoading}
//                         />
//                       </div>
//                     </div>
//                   )}

//                   {/* --- KODE YANG SEBELUMNYA DI-SKIP (VIDEO & INSTAGRAM) --- */}

//                   {formData.content_type === 'video_youtube' && (
//                     <div>
//                       <Label>URL Embed YouTube</Label>
//                       <Input
//                         value={formData.content_data.embed_url || ""}
//                         onChange={(e) => setFormData({
//                           ...formData,
//                           content_data: { ...formData.content_data, embed_url: e.target.value }
//                         })}
//                       />
//                     </div>
//                   )}

//                   {formData.content_type === 'video_tiktok' && (
//                     <div>
//                       <Label>URL TikTok</Label>
//                       <Input
//                         value={formData.content_data.original_url || ""}
//                         onChange={(e) => setFormData({
//                           ...formData,
//                           content_data: { ...formData.content_data, original_url: e.target.value }
//                         })}
//                       />
//                     </div>
//                   )}

//                   {(formData.content_type === 'image' || formData.content_type === 'video_upload') && (
//                     <div>
//                       <Label>Upload File</Label>
//                       <Input
//                         type="file"
//                         onChange={handleFileUpload}
//                         disabled={uploadLoading}
//                       />
//                     </div>
//                   )}

//                   {['image', 'video_upload'].includes(formData.content_type) && (
//                     <div className="p-4 border rounded-lg space-y-4 bg-gray-50">
//                       <h4 className="font-medium text-sm text-gray-700">Opsi Tampilan Media</h4>
//                       <div>
//                         <Label htmlFor="aspect_ratio">Aspect Ratio</Label>
//                         <Select
//                           value={formData.content_data.display_options?.aspect_ratio || "auto"}
//                           onValueChange={(value) => setFormData(prev => ({
//                             ...prev,
//                             content_data: {
//                               ...prev.content_data,
//                               display_options: {
//                                 ...prev.content_data.display_options,
//                                 aspect_ratio: value
//                               }
//                             }
//                           }))}
//                         >
//                           <SelectTrigger id="aspect_ratio">
//                             <SelectValue placeholder="Pilih rasio" />
//                           </SelectTrigger>
//                           <SelectContent>
//                             <SelectItem value="auto">Otomatis</SelectItem>
//                             <SelectItem value="16/9">16:9 (Landscape)</SelectItem>
//                             <SelectItem value="9/16">9:16 (Portrait)</SelectItem>
//                             <SelectItem value="4/3">4:3 (Standard)</SelectItem>
//                             <SelectItem value="1/1">1:1 (Square)</SelectItem>
//                           </SelectContent>
//                         </Select>
//                       </div>
//                     </div>
//                   )}

//                   {formData.content_type === 'instagram_reel' && (
//                     <div className="space-y-4">
//                       <div>
//                         <Label htmlFor="instagram_url">URL Instagram Reel</Label>
//                         <Input
//                           id="instagram_url"
//                           value={formData.content_data.original_url || ""}
//                           onChange={(e) => setFormData({
//                             ...formData,
//                             content_data: { ...formData.content_data, original_url: e.target.value }
//                           })}
//                           placeholder="https://www.instagram.com/reel/..."
//                         />
//                       </div>
//                       <div>
//                         <Label htmlFor="reel_thumbnail">Upload Thumbnail</Label>
//                         <Input
//                           id="reel_thumbnail"
//                           type="file"
//                           accept="image/*"
//                           onChange={handleThumbnailUpload}
//                           disabled={uploadLoading}
//                         />
//                         {formData.content_data.thumbnail_url && (
//                           <div className="mt-2">
//                             <img src={formData.content_data.thumbnail_url} alt="Thumbnail" className="w-32 h-32 object-cover rounded-lg" />
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   )}

//                   {formData.content_type === 'instagram_feed' && (
//                     <div className="space-y-4">
//                       <div>
//                         <Label htmlFor="instagram_feed_url">URL Instagram Feed</Label>
//                         <Input
//                           id="instagram_feed_url"
//                           value={formData.content_data.original_url || ""}
//                           onChange={(e) => setFormData({
//                             ...formData,
//                             content_data: { ...formData.content_data, original_url: e.target.value }
//                           })}
//                           placeholder="https://www.instagram.com/p/..."
//                         />
//                       </div>
//                       <div>
//                         <Label htmlFor="feed_thumbnail">Upload Thumbnail</Label>
//                         <Input
//                           id="feed_thumbnail"
//                           type="file"
//                           accept="image/*"
//                           onChange={handleThumbnailUpload}
//                           disabled={uploadLoading}
//                         />
//                         {formData.content_data.thumbnail_url && (
//                           <div className="mt-2">
//                             <img src={formData.content_data.thumbnail_url} alt="Thumbnail" className="w-32 h-32 object-cover rounded-lg" />
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   )}

//                   {/* --- BAGIAN KHUSUS FILE DENGAN COVER IMAGE --- */}
//                   {(formData.content_type === 'file') && (
//                     <div className="space-y-4 border p-4 rounded-lg bg-gray-50">
//                       <div>
//                         <Label>Upload File (PDF/Doc)</Label>
//                         <Input
//                           type="file"
//                           accept=".pdf,.doc,.docx,.txt"
//                           onChange={handleFileUpload}
//                           disabled={uploadLoading}
//                         />
//                         {formData.content_data.url && (
//                           <p className="text-xs text-green-600 mt-1 truncate">
//                             File terupload: {formData.content_data.filename || 'File'}
//                           </p>
//                         )}
//                       </div>

//                       <Separator className="my-2" />

//                       <div>
//                         <Label className="mb-2 block">Background Cover Image (Opsional)</Label>
//                         <div className="flex gap-2 mb-2">
//                           <Input
//                             placeholder="Paste URL Public Image disini..."
//                             value={formData.content_data.cover_image_url || ""}
//                             onChange={(e) => setFormData({
//                               ...formData,
//                               content_data: { ...formData.content_data, cover_image_url: e.target.value }
//                             })}
//                           />
//                         </div>
//                         <div className="flex items-center gap-2">
//                           <span className="text-xs text-gray-500">Atau upload gambar:</span>
//                           <Input
//                             type="file"
//                             accept="image/*"
//                             onChange={handleCoverImageUpload}
//                             disabled={uploadLoading}
//                             className="w-auto"
//                           />
//                         </div>
//                         {formData.content_data.cover_image_url && (
//                           <div className="mt-2">
//                             <p className="text-xs text-gray-500 mb-1">Preview Cover:</p>
//                             <div
//                               className="w-full h-24 rounded bg-cover bg-center"
//                               style={{ backgroundImage: `url(${formData.content_data.cover_image_url})` }}
//                             ></div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   )}

//                   <div>
//                     <Label htmlFor="folder">Folder</Label>
//                     <Select
//                       value={formData.folder || "no-folder"}
//                       onValueChange={(value) => setFormData({ ...formData, folder: value })}
//                     >
//                       <SelectTrigger>
//                         <SelectValue placeholder="Pilih folder (opsional)" />
//                       </SelectTrigger>
//                       <SelectContent>
//                         <SelectItem value="no-folder">Tanpa Folder</SelectItem>
//                         {folders.map((folder) => (
//                           <SelectItem key={folder.id} value={folder.id}>{folder.name}</SelectItem>
//                         ))}
//                       </SelectContent>
//                     </Select>
//                   </div>

//                   <div>
//                     <Label htmlFor="tags">Tags (pisahkan dengan koma)</Label>
//                     <Input
//                       id="tags"
//                       value={formData.tags.join(", ")}
//                       onChange={(e) => setFormData({
//                         ...formData,
//                         tags: e.target.value.split(",").map(tag => tag.trim())
//                       })}
//                       placeholder="Kasir, QRIS, PPN"
//                     />
//                   </div>

//                   <div>
//                     <Label htmlFor="description">Deskripsi</Label>
//                     <Textarea
//                       id="description"
//                       value={formData.description}
//                       onChange={(e) => setFormData({ ...formData, description: e.target.value })}
//                       placeholder="Deskripsi singkat konten..."
//                     />
//                   </div>

//                   <Button type="submit" className="w-full" disabled={uploadLoading}>
//                     {uploadLoading ? "Uploading..." : selectedContent ? "Update Konten" : "Simpan Konten"}
//                   </Button>
//                 </form>
//               </DialogContent>
//             </Dialog>
//           </div>
//         </div>

//         {loading ? (
//           <div className="text-center py-8">
//             <p>Loading...</p>
//           </div>
//         ) : (
//           <FolderContentView
//             contents={contents}
//             selectedContents={selectedContents}
//             setSelectedContents={setSelectedContents}
//             openEditDialog={openEditDialog}
//             handleDelete={handleDelete}
//           />
//         )}
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 flex">
//       <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform lg:translate-x-0 lg:static lg:inset-0`}>
//         <div className="flex items-center justify-between h-16 px-6 border-b">
//           <h1 className="text-xl font-bold text-gray-800">Admin Panel</h1>
//           <Button
//             variant="ghost"
//             size="sm"
//             className="lg:hidden"
//             onClick={() => setSidebarOpen(false)}
//           >
//             ×
//           </Button>
//         </div>

//         <nav className="mt-8">
//           <button
//             onClick={() => setActiveTab('content')}
//             className={`w-full flex items-center px-6 py-3 ${activeTab === 'content' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
//               }`}
//           >
//             <Folder className="w-5 h-5 mr-3" />
//             Kelola Konten
//           </button>
//           <button
//             onClick={() => setActiveTab('slides')}
//             className={`w-full flex items-center px-6 py-3 ${activeTab === 'slides' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
//               }`}
//           >
//             <Image className="w-5 h-5 mr-3" />
//             Kelola Slides
//           </button>
//           <button
//             onClick={() => setActiveTab('upload')}
//             className={`w-full flex items-center px-6 py-3 ${activeTab === 'upload' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
//               }`}
//           >
//             <Upload className="w-5 h-5 mr-3" />
//             Upload Files
//           </button>
//         </nav>

//         <div className="absolute bottom-0 left-0 right-0 p-6 border-t">
//           <Button
//             variant="outline"
//             onClick={logout}
//             className="w-full"
//           >
//             <LogOut className="w-4 h-4 mr-2" />
//             Logout
//           </Button>
//         </div>
//       </div>

//       <div className="flex-1 flex flex-col lg:ml-0">
//         <header className="bg-white shadow-sm border-b h-16 flex items-center justify-between px-6">
//           <Button
//             variant="ghost"
//             size="sm"
//             className="lg:hidden"
//             onClick={() => setSidebarOpen(true)}
//           >
//             <Menu className="w-5 h-5" />
//           </Button>

//           <div className="flex items-center space-x-4">
//             <span className="text-sm text-gray-600">Welcome, Admin</span>
//             <User className="w-8 h-8 text-gray-400" />
//           </div>
//         </header>

//         <main className="flex-1 p-6">
//           {renderContent()}
//         </main>
//       </div>

//       {sidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
//           onClick={() => setSidebarOpen(false)}
//         />
//       )}
//     </div>
//   );
// };

// // Protected Route Component
// const ProtectedRoute = ({ children }) => {
//   const { isAuthenticated, loading } = useAuth();

//   if (loading) {
//     return <div className="flex items-center justify-center h-screen">Loading...</div>;
//   }

//   return isAuthenticated ? children : <Navigate to="/admin/login" />;
// };

// // Article Page Component
// const ArticlePage = () => {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   return (
//     <ArticleView
//       articleId={id}
//       onBack={() => navigate('/')}
//     />
//   );
// };

// // Main App Component
// function App() {
//   return (
//     <AuthProvider>
//       <BrowserRouter>
//         <Routes>
//           <Route path="/" element={<ModernHomepage />} />
//           <Route path="/article/:id" element={<ArticlePage />} />
//           <Route path="/admin/login" element={<LoginPage />} />
//           <Route
//             path="/admin"
//             element={
//               <ProtectedRoute>
//                 <AdminDashboard />
//               </ProtectedRoute>
//             }
//           />
//         </Routes>
//         <Toaster />
//       </BrowserRouter>
//     </AuthProvider>
//   );
// }

// export default App;

import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Button } from "./components/ui/button";
import { Input } from "./components/ui/input";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./components/ui/card";
import { Badge } from "./components/ui/badge";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./components/ui/tabs";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./components/ui/dialog";
import { Label } from "./components/ui/label";
import { Textarea } from "./components/ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./components/ui/select";
import { Separator } from "./components/ui/separator";
import { Search, Video, FileText, Image, Upload, Plus, Edit, Trash2, LogOut, User, ExternalLink, Smartphone, Instagram, Facebook, MessageCircle, Newspaper, Menu, Home, Settings, BarChart3, Folder, ExternalLinkIcon } from "lucide-react";
import { toast, Toaster } from "sonner";
import FolderContentView from "./components/FolderContentView";
import ModernHomepage from "./components/ModernHomepage";
import ArticleView from "./components/ArticleView";
import SlideManager from "./components/SlideManager";
import { Switch } from "./components/ui/switch";
import AnalyticsDashboard from "./components/AnalyticsDashboard"; // Import Analytics Dashboard

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Utility function to add cache-busting for R2 URLs
const addCacheBusting = (url) => {
  if (!url) return url;
  if (url.includes('.r2.dev') || url.includes('cloudflare')) {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}cb=${Date.now()}`;
  }
  return url;
};

const AuthContext = React.createContext();

const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      try {
        const response = await axios.get(`${API}/auth/me`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setUser(response.data);
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.removeItem('auth_token');
        setIsAuthenticated(false);
        setUser(null);
      }
    }
    setLoading(false);
  };

  const login = async (username, password) => {
    try {
      const response = await axios.post(`${API}/auth/login`, {
        username,
        password
      });

      const { token } = response.data;
      localStorage.setItem('auth_token', token);
      setIsAuthenticated(true);

      const userResponse = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(userResponse.data);

      return { success: true };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.detail || 'Login failed'
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('auth_token');
    setIsAuthenticated(false);
    setUser(null);
  };

  const value = {
    isAuthenticated,
    user,
    login,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

// Public Search Page
const SearchPage = () => {
  return <ModernHomepage />;
};

// Login Page
const LoginPage = () => {
  const [formData, setFormData] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const { login, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(formData.username, formData.password);

    if (result.success) {
      toast.success("Login berhasil!");
      navigate('/admin');
    } else {
      toast.error(result.error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Admin Login</CardTitle>
          <CardDescription>Masukkan kredensial admin</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="username">Username</Label>
              <Input
                id="username"
                type="text"
                value={formData.username}
                onChange={(e) => setFormData({ ...formData, username: e.target.value })}
                required
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                required
              />
            </div>
            <Button type="submit" className="w-full" disabled={loading}>
              {loading ? "Loading..." : "Login"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

// Admin Dashboard
const AdminDashboard = () => {
  const [contents, setContents] = useState([]);
  const [folders, setFolders] = useState([]);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [selectedContent, setSelectedContent] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [folderDialogOpen, setFolderDialogOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('content');
  const [searchAnalytics, setSearchAnalytics] = useState(null);
  const [selectedContents, setSelectedContents] = useState([]);
  const { logout } = useAuth();

  const [formData, setFormData] = useState({
    title: "",
    content_type: "article",
    content_data: {},
    tags: [],
    folder: "",
    description: ""
  });

  const [folderFormData, setFolderFormData] = useState({
    name: "",
    description: "",
    color: "#3B82F6"
  });

  useEffect(() => {
    fetchFolders();
  }, []);

  useEffect(() => {
    if (selectedFolder !== null) {
      fetchFolderContents();
    }
  }, [selectedFolder]);

  // Effect for scripts
  useEffect(() => {
    const tiktokScriptId = 'tiktok-embed-script';
    if (!document.getElementById(tiktokScriptId)) {
      const script = document.createElement('script');
      script.id = tiktokScriptId;
      script.src = 'https://www.tiktok.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
    } else if (window.tiktok) {
      window.tiktok.load();
    }

    const instaScriptId = 'instagram-embed-script';
    if (!document.getElementById(instaScriptId)) {
      const script = document.createElement('script');
      script.id = instaScriptId;
      script.src = '//www.instagram.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
    } else if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, [dialogOpen, contents]);

  const fetchFolders = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API}/admin/folders`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setFolders(response.data);
    } catch (error) {
      toast.error("Error mengambil folders");
    }
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const formDataUpload = new FormData();
      formDataUpload.append('file', file);
      formDataUpload.append('folder', 'content-files');

      const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      // Keep existing content_data, update url info
      setFormData(prev => ({
        ...prev,
        content_data: {
          ...prev.content_data,
          url: response.data.file_url,
          file_name: response.data.file_name,
          file_type: response.data.file_type,
          file_size: response.data.file_size
        }
      }));

      toast.success("File berhasil diupload!");
    } catch (error) {
      toast.error("Error upload file: " + (error.response?.data?.detail || "Unknown error"));
    } finally {
      setUploadLoading(false);
    }
  };

  // NEW FUNCTION: Handle Cover Image Upload for Files
  const handleCoverImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const formDataUpload = new FormData();
      formDataUpload.append('file', file);
      formDataUpload.append('folder', 'covers'); // Upload to 'covers' folder

      const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      // Save to content_data.cover_image_url
      setFormData(prev => ({
        ...prev,
        content_data: {
          ...prev.content_data,
          cover_image_url: response.data.file_url
        }
      }));

      toast.success("Cover image berhasil diupload!");
    } catch (error) {
      toast.error("Error upload cover: " + (error.response?.data?.detail || "Unknown error"));
    } finally {
      setUploadLoading(false);
    }
  };

  const handleThumbnailUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const formDataUpload = new FormData();
      formDataUpload.append('file', file);
      formDataUpload.append('folder', 'thumbnails');

      const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setFormData(prev => ({
        ...prev,
        content_data: {
          ...prev.content_data,
          thumbnail_url: response.data.file_url
        }
      }));

      toast.success("Thumbnail berhasil diupload!");
    } catch (error) {
      toast.error("Error upload thumbnail: " + (error.response?.data?.detail || "Unknown error"));
    } finally {
      setUploadLoading(false);
    }
  };

  const handlePdfUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setUploadLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const formDataUpload = new FormData();
      formDataUpload.append('file', file);
      formDataUpload.append('folder', 'pdfs');

      const response = await axios.post(`${API}/admin/upload`, formDataUpload, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setFormData(prev => ({
        ...prev,
        content_data: {
          ...prev.content_data,
          pdf_url: response.data.file_url,
          pdf_name: response.data.file_name
        }
      }));

      toast.success("PDF berhasil diupload!");
    } catch (error) {
      toast.error("Error upload PDF: " + (error.response?.data?.detail || "Unknown error"));
    } finally {
      setUploadLoading(false);
    }
  };

  const fetchFolderContents = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('auth_token');
      const response = await axios.get(`${API}/admin/folders/${selectedFolder}/contents`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setContents(response.data);
    } catch (error) {
      toast.error("Error mengambil konten folder");
    } finally {
      setLoading(false);
    }
  };

  const createFolder = async () => {
    try {
      const token = localStorage.getItem('auth_token');
      await axios.post(`${API}/admin/folders`, folderFormData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Folder berhasil dibuat!");
      setFolderDialogOpen(false);
      setFolderFormData({ name: "", description: "", color: "#3B82F6" });
      fetchFolders();
    } catch (error) {
      toast.error("Error membuat folder: " + (error.response?.data?.detail || "Unknown error"));
    }
  };

  const moveContentToFolder = async (targetFolder = null) => {
    if (selectedContents.length === 0) {
      toast.error("Pilih konten yang ingin dipindah");
      return;
    }

    try {
      const token = localStorage.getItem('auth_token');
      await axios.post(`${API}/admin/folders/move`, {
        content_ids: selectedContents,
        target_folder: targetFolder
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Konten berhasil dipindah!");
      setSelectedContents([]);
      fetchFolderContents();
    } catch (error) {
      toast.error("Error memindah konten");
    }
  };

  const openEditDialog = (content) => {
    setSelectedContent(content);
    setFormData({
      title: content.title,
      content_type: content.content_type,
      content_data: content.content_data,
      tags: content.tags,
      folder: content.folder || "no-folder",
      description: content.description || ""
    });
    setDialogOpen(true);
  };

  const handleDelete = async (contentId) => {
    if (!window.confirm("Apakah Anda yakin ingin menghapus konten ini?")) return;

    try {
      const token = localStorage.getItem('auth_token');
      await axios.delete(`${API}/admin/content/${contentId}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Konten berhasil dihapus!");
      fetchFolderContents();
    } catch (error) {
      toast.error("Error menghapus konten");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const token = localStorage.getItem('auth_token');

      const submitData = {
        ...formData,
        folder: formData.folder === 'no-folder' ? null : formData.folder
      };

      if (selectedContent) {
        await axios.put(`${API}/admin/content/${selectedContent.id}`, submitData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success("Konten berhasil diperbarui!");
      } else {
        await axios.post(`${API}/admin/content`, submitData, {
          headers: { Authorization: `Bearer ${token}` }
        });
        toast.success("Konten berhasil dibuat!");
      }

      setDialogOpen(false);
      resetForm();
      if (selectedFolder !== null) {
        fetchFolderContents();
      }
    } catch (error) {
      toast.error("Error menyimpan konten: " + (error.response?.data?.detail || "Unknown error"));
    }
  };

  const resetForm = () => {
    setFormData({
      title: "",
      content_type: "article",
      content_data: {},
      tags: [],
      folder: selectedFolder && selectedFolder !== 'no-folder' ? selectedFolder : "no-folder",
      description: ""
    });
    setSelectedContent(null);
  };

  const renderContent = () => {
    if (activeTab === 'upload') {
      return (
        <div className="space-y-6">
          <h2 className="text-2xl font-bold text-gray-800">Upload Files</h2>
          <Card className="p-6">
            <CardContent>
              <div className="text-center py-8">
                <Upload className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                <p className="text-gray-600">Upload file langsung ke R2 Storage</p>
              </div>
            </CardContent>
          </Card>
        </div>
      );
    }

    if (activeTab === 'slides') return <SlideManager />;

    // INTEGRASI ANALYTICS DASHBOARD
    if (activeTab === 'analytics') return <AnalyticsDashboard />;

    if (selectedFolder === null) {
      return (
        <div className="space-y-6">
          <div className="flex justify-between items-center">
            <h2 className="text-2xl font-bold text-gray-800">Folder Konten</h2>
            <Dialog open={folderDialogOpen} onOpenChange={setFolderDialogOpen}>
              <DialogTrigger asChild>
                <Button>
                  <Plus className="w-4 h-4 mr-2" />
                  Buat Folder Baru
                </Button>
              </DialogTrigger>
              <DialogContent>
                <DialogHeader>
                  <DialogTitle>Buat Folder Baru</DialogTitle>
                </DialogHeader>
                <div className="space-y-4">
                  <div>
                    <Label htmlFor="folder_name">Nama Folder</Label>
                    <Input
                      id="folder_name"
                      value={folderFormData.name}
                      onChange={(e) => setFolderFormData({ ...folderFormData, name: e.target.value })}
                      placeholder="Nama folder (contoh: QRIS, PLN, PPN)"
                    />
                  </div>
                  <div>
                    <Label htmlFor="folder_description">Deskripsi</Label>
                    <Textarea
                      id="folder_description"
                      value={folderFormData.description}
                      onChange={(e) => setFolderFormData({ ...folderFormData, description: e.target.value })}
                      placeholder="Deskripsi folder (opsional)"
                    />
                  </div>
                  <div>
                    <Label htmlFor="folder_color">Warna</Label>
                    <Input
                      id="folder_color"
                      type="color"
                      value={folderFormData.color}
                      onChange={(e) => setFolderFormData({ ...folderFormData, color: e.target.value })}
                    />
                  </div>
                  <Button onClick={createFolder} className="w-full">
                    Buat Folder
                  </Button>
                </div>
              </DialogContent>
            </Dialog>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            <Card
              className="cursor-pointer hover:shadow-md transition-shadow border-2 border-dashed border-gray-300"
              onClick={() => setSelectedFolder('no-folder')}
            >
              <CardContent className="p-6 text-center">
                <Folder className="w-12 h-12 mx-auto mb-4 text-gray-400" />
                <h3 className="font-semibold text-gray-700">Tanpa Folder</h3>
                <p className="text-sm text-gray-500 mt-1">Konten yang belum dikategorikan</p>
              </CardContent>
            </Card>

            {folders.map((folder) => (
              <Card
                key={folder.id}
                className="cursor-pointer hover:shadow-md transition-shadow"
                onClick={() => setSelectedFolder(folder.id)}
                style={{ borderTop: `4px solid ${folder.color}` }}
              >
                <CardContent className="p-6 text-center">
                  <div
                    className="w-12 h-12 mx-auto mb-4 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: folder.color + '20' }}
                  >
                    <Folder className="w-6 h-6" style={{ color: folder.color }} />
                  </div>
                  <h3 className="font-semibold">{folder.name}</h3>
                  {folder.description && (
                    <p className="text-sm text-gray-500 mt-1">{folder.description}</p>
                  )}
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      );
    }

    return (
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-3">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setSelectedFolder(null)}
            >
              ← Kembali
            </Button>
            <h2 className="text-2xl font-bold text-gray-800">
              {folders.find(f => f.id === selectedFolder)?.name || 'Tanpa Folder'}
            </h2>
            <Badge variant="outline">{contents.length} konten</Badge>
          </div>
          <div className="flex gap-2">
            {selectedContents.length > 0 && (
              <div className="flex gap-2">
                <Select onValueChange={(value) => moveContentToFolder(value === 'no-folder' ? null : value)}>
                  <SelectTrigger className="w-40">
                    <SelectValue placeholder="Pindah ke..." />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="no-folder">Tanpa Folder</SelectItem>
                    {folders.filter(f => f.id !== selectedFolder).map((folder) => (
                      <SelectItem key={folder.id} value={folder.id}>{folder.name}</SelectItem>
                    ))}
                  </SelectContent>
                </Select>
                <Button variant="outline" onClick={() => setSelectedContents([])}>
                  Batal Pilih ({selectedContents.length})
                </Button>
              </div>
            )}
            <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
              <DialogTrigger asChild>
                <Button onClick={resetForm}>
                  <Plus className="w-4 h-4 mr-2" />
                  Tambah Konten
                </Button>
              </DialogTrigger>
              <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>
                    {selectedContent ? "Edit Konten" : "Tambah Konten Baru"}
                  </DialogTitle>
                </DialogHeader>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <div>
                    <Label htmlFor="title">Judul</Label>
                    <Input
                      id="title"
                      value={formData.title}
                      onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                      required
                    />
                  </div>

                  <div>
                    <Label htmlFor="content_type">Tipe Konten</Label>
                    <Select
                      value={formData.content_type}
                      onValueChange={(value) => setFormData({ ...formData, content_type: value, content_data: {} })}
                    >
                      <SelectTrigger>
                        <SelectValue />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="article">Artikel</SelectItem>
                        <SelectItem value="video_youtube">Video YouTube</SelectItem>
                        <SelectItem value="video_tiktok">Video TikTok</SelectItem>
                        <SelectItem value="instagram_reel">Instagram Reel</SelectItem>
                        <SelectItem value="instagram_feed">Instagram Feed</SelectItem>
                        <SelectItem value="video_upload">Video Upload</SelectItem>
                        <SelectItem value="image">Gambar</SelectItem>
                        <SelectItem value="file">File</SelectItem>
                      </SelectContent>
                    </Select>
                  </div>

                  {/* DYNAMIC INPUTS BASED ON TYPE */}
                  {formData.content_type === 'article' && (
                    <div className="space-y-4">
                      <div>
                        <Label>Teks Artikel</Label>
                        <Textarea
                          value={formData.content_data.text || ""}
                          onChange={(e) => setFormData({
                            ...formData,
                            content_data: { ...formData.content_data, text: e.target.value }
                          })}
                          rows={6}
                        />
                      </div>
                      <div>
                        <Label>Upload PDF</Label>
                        <Input
                          type="file"
                          accept=".pdf"
                          onChange={handlePdfUpload}
                          disabled={uploadLoading}
                        />
                      </div>
                    </div>
                  )}

                  {/* --- KODE YANG SEBELUMNYA DI-SKIP (VIDEO & INSTAGRAM) --- */}

                  {formData.content_type === 'video_youtube' && (
                    <div>
                      <Label>URL Embed YouTube</Label>
                      <Input
                        value={formData.content_data.embed_url || ""}
                        onChange={(e) => setFormData({
                          ...formData,
                          content_data: { ...formData.content_data, embed_url: e.target.value }
                        })}
                      />
                    </div>
                  )}

                  {formData.content_type === 'video_tiktok' && (
                    <div>
                      <Label>URL TikTok</Label>
                      <Input
                        value={formData.content_data.original_url || ""}
                        onChange={(e) => setFormData({
                          ...formData,
                          content_data: { ...formData.content_data, original_url: e.target.value }
                        })}
                      />
                    </div>
                  )}

                  {(formData.content_type === 'image' || formData.content_type === 'video_upload') && (
                    <div>
                      <Label>Upload File</Label>
                      <Input
                        type="file"
                        onChange={handleFileUpload}
                        disabled={uploadLoading}
                      />
                    </div>
                  )}

                  {['image', 'video_upload'].includes(formData.content_type) && (
                    <div className="p-4 border rounded-lg space-y-4 bg-gray-50">
                      <h4 className="font-medium text-sm text-gray-700">Opsi Tampilan Media</h4>
                      <div>
                        <Label htmlFor="aspect_ratio">Aspect Ratio</Label>
                        <Select
                          value={formData.content_data.display_options?.aspect_ratio || "auto"}
                          onValueChange={(value) => setFormData(prev => ({
                            ...prev,
                            content_data: {
                              ...prev.content_data,
                              display_options: {
                                ...prev.content_data.display_options,
                                aspect_ratio: value
                              }
                            }
                          }))}
                        >
                          <SelectTrigger id="aspect_ratio">
                            <SelectValue placeholder="Pilih rasio" />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="auto">Otomatis</SelectItem>
                            <SelectItem value="16/9">16:9 (Landscape)</SelectItem>
                            <SelectItem value="9/16">9:16 (Portrait)</SelectItem>
                            <SelectItem value="4/3">4:3 (Standard)</SelectItem>
                            <SelectItem value="1/1">1:1 (Square)</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>
                  )}

                  {formData.content_type === 'instagram_reel' && (
                    <div className="space-y-4">
                      <div>
                        <Label htmlFor="instagram_url">URL Instagram Reel</Label>
                        <Input
                          id="instagram_url"
                          value={formData.content_data.original_url || ""}
                          onChange={(e) => setFormData({
                            ...formData,
                            content_data: { ...formData.content_data, original_url: e.target.value }
                          })}
                          placeholder="https://www.instagram.com/reel/..."
                        />
                      </div>
                      <div>
                        <Label htmlFor="reel_thumbnail">Upload Thumbnail</Label>
                        <Input
                          id="reel_thumbnail"
                          type="file"
                          accept="image/*"
                          onChange={handleThumbnailUpload}
                          disabled={uploadLoading}
                        />
                        {formData.content_data.thumbnail_url && (
                          <div className="mt-2">
                            <img src={formData.content_data.thumbnail_url} alt="Thumbnail" className="w-32 h-32 object-cover rounded-lg" />
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {formData.content_type === 'instagram_feed' && (
                    <div className="space-y-4">
                      <div>
                        <Label htmlFor="instagram_feed_url">URL Instagram Feed</Label>
                        <Input
                          id="instagram_feed_url"
                          value={formData.content_data.original_url || ""}
                          onChange={(e) => setFormData({
                            ...formData,
                            content_data: { ...formData.content_data, original_url: e.target.value }
                          })}
                          placeholder="https://www.instagram.com/p/..."
                        />
                      </div>
                      <div>
                        <Label htmlFor="feed_thumbnail">Upload Thumbnail</Label>
                        <Input
                          id="feed_thumbnail"
                          type="file"
                          accept="image/*"
                          onChange={handleThumbnailUpload}
                          disabled={uploadLoading}
                        />
                        {formData.content_data.thumbnail_url && (
                          <div className="mt-2">
                            <img src={formData.content_data.thumbnail_url} alt="Thumbnail" className="w-32 h-32 object-cover rounded-lg" />
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* --- BAGIAN KHUSUS FILE DENGAN COVER IMAGE --- */}
                  {(formData.content_type === 'file') && (
                    <div className="space-y-4 border p-4 rounded-lg bg-gray-50">
                      <div>
                        <Label>Upload File (PDF/Doc)</Label>
                        <Input
                          type="file"
                          accept=".pdf,.doc,.docx,.txt"
                          onChange={handleFileUpload}
                          disabled={uploadLoading}
                        />
                        {formData.content_data.url && (
                          <p className="text-xs text-green-600 mt-1 truncate">
                            File terupload: {formData.content_data.filename || 'File'}
                          </p>
                        )}
                      </div>

                      <Separator className="my-2" />

                      <div>
                        <Label className="mb-2 block">Background Cover Image (Opsional)</Label>
                        <div className="flex gap-2 mb-2">
                          <Input
                            placeholder="Paste URL Public Image disini..."
                            value={formData.content_data.cover_image_url || ""}
                            onChange={(e) => setFormData({
                              ...formData,
                              content_data: { ...formData.content_data, cover_image_url: e.target.value }
                            })}
                          />
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs text-gray-500">Atau upload gambar:</span>
                          <Input
                            type="file"
                            accept="image/*"
                            onChange={handleCoverImageUpload}
                            disabled={uploadLoading}
                            className="w-auto"
                          />
                        </div>
                        {formData.content_data.cover_image_url && (
                          <div className="mt-2">
                            <p className="text-xs text-gray-500 mb-1">Preview Cover:</p>
                            <div
                              className="w-full h-24 rounded bg-cover bg-center"
                              style={{ backgroundImage: `url(${formData.content_data.cover_image_url})` }}
                            ></div>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <div>
                    <Label htmlFor="folder">Folder</Label>
                    <Select
                      value={formData.folder || "no-folder"}
                      onValueChange={(value) => setFormData({ ...formData, folder: value })}
                    >
                      <SelectTrigger>
                        <SelectValue placeholder="Pilih folder (opsional)" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="no-folder">Tanpa Folder</SelectItem>
                        {folders.map((folder) => (
                          <SelectItem key={folder.id} value={folder.id}>{folder.name}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>

                  <div>
                    <Label htmlFor="tags">Tags (pisahkan dengan koma)</Label>
                    <Input
                      id="tags"
                      value={formData.tags.join(", ")}
                      onChange={(e) => setFormData({
                        ...formData,
                        tags: e.target.value.split(",").map(tag => tag.trim())
                      })}
                      placeholder="Kasir, QRIS, PPN"
                    />
                  </div>

                  <div>
                    <Label htmlFor="description">Deskripsi</Label>
                    <Textarea
                      id="description"
                      value={formData.description}
                      onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                      placeholder="Deskripsi singkat konten..."
                    />
                  </div>

                  <Button type="submit" className="w-full" disabled={uploadLoading}>
                    {uploadLoading ? "Uploading..." : selectedContent ? "Update Konten" : "Simpan Konten"}
                  </Button>
                </form>
              </DialogContent>
            </Dialog>
          </div>
        </div>

        {loading ? (
          <div className="text-center py-8">
            <p>Loading...</p>
          </div>
        ) : (
          <FolderContentView
            contents={contents}
            selectedContents={selectedContents}
            setSelectedContents={setSelectedContents}
            openEditDialog={openEditDialog}
            handleDelete={handleDelete}
          />
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <div className={`fixed inset-y-0 left-0 z-50 w-64 bg-white shadow-lg transform ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform lg:translate-x-0 lg:static lg:inset-0`}>
        <div className="flex items-center justify-between h-16 px-6 border-b">
          <h1 className="text-xl font-bold text-gray-800">Admin Panel</h1>
          <Button
            variant="ghost"
            size="sm"
            className="lg:hidden"
            onClick={() => setSidebarOpen(false)}
          >
            ×
          </Button>
        </div>

        <nav className="mt-8">
          <button
            onClick={() => setActiveTab('content')}
            className={`w-full flex items-center px-6 py-3 ${activeTab === 'content' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
              }`}
          >
            <Folder className="w-5 h-5 mr-3" />
            Kelola Konten
          </button>
          <button
            onClick={() => setActiveTab('slides')}
            className={`w-full flex items-center px-6 py-3 ${activeTab === 'slides' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
              }`}
          >
            <Image className="w-5 h-5 mr-3" />
            Kelola Slides
          </button>
          <button
            onClick={() => setActiveTab('upload')}
            className={`w-full flex items-center px-6 py-3 ${activeTab === 'upload' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
              }`}
          >
            <Upload className="w-5 h-5 mr-3" />
            Upload Files
          </button>
          {/* TOMBOL ANALYTICS BARU */}
          <button
            onClick={() => setActiveTab('analytics')}
            className={`w-full flex items-center px-6 py-3 ${activeTab === 'analytics' ? 'bg-blue-50 text-blue-700 border-r-4 border-blue-500' : 'text-gray-700'
              }`}
          >
            <BarChart3 className="w-5 h-5 mr-3" />
            Analytics
          </button>
        </nav>

        <div className="absolute bottom-0 left-0 right-0 p-6 border-t">
          <Button
            variant="outline"
            onClick={logout}
            className="w-full"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout
          </Button>
        </div>
      </div>

      <div className="flex-1 flex flex-col lg:ml-0">
        <header className="bg-white shadow-sm border-b h-16 flex items-center justify-between px-6">
          <Button
            variant="ghost"
            size="sm"
            className="lg:hidden"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="w-5 h-5" />
          </Button>

          <div className="flex items-center space-x-4">
            <span className="text-sm text-gray-600">Welcome, Admin</span>
            <User className="w-8 h-8 text-gray-400" />
          </div>
        </header>

        <main className="flex-1 p-6">
          {renderContent()}
        </main>
      </div>

      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/admin/login" />;
};

// Article Page Component
const ArticlePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <ArticleView
      articleId={id}
      onBack={() => navigate('/')}
    />
  );
};

// Main App Component
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ModernHomepage />} />
          <Route path="/article/:id" element={<ArticlePage />} />
          <Route path="/admin/login" element={<LoginPage />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;